export const NetworkErrorImageUrl = 'img/temp/network-error.png'

export const NotiItemAccountNumberCount = 4
export const NotificationRequestRowCount = 10

export enum NotiType {
  General = '1', // 일반 (General) – 추가 param없음
  Income = '2', // 입금 (Income) – 계좌명(계좌번호 뒤4자리)
  Output = '3', // 출금 (Output) – 계좌명(계좌번호 뒤4자리)
  DebitCard = '4', // Debit Card (debitCard)
  Deposit = '5', // 예적금 (Deposit)
  QuickCash = '6', // 대출 (Loan)
  QuickCredit = '7', // 대출 (Loan)
  TEST = '0', // /noti/list 응답으로 loan의 notiCateCd가 0으로 들어와 테스트용 추가
}

export interface INotiResponse {
  acctNo: string
  acctTitle: string
  notiCateCd: NotiType
  notiContent: {
    body?: string
    landingScheme?: string
    title: string
  }
  notiNo: number
  notiTypeCd: string
  trxDtm: number
}

export interface INotiResponseGroupMap {
  [key: string]: INotiResponse[]
}

export function getItemInfo(value: NotiType) {
  switch (value) {
    case NotiType.General:
      return {
        type: 'General',
        notiTypeCode: '',
        icon: 'noti-ctr__ico--general',
      }
    case NotiType.Income:
      return {
        type: 'Income',
        notiTypeCode: 'noticenter_display_accname',
        icon: 'noti-ctr__ico--deposit',
      }
    case NotiType.Output:
      return {
        type: 'Output',
        notiTypeCode: 'noticenter_display_accname',
        icon: 'noti-ctr__ico--withdrawal',
      }
    case NotiType.DebitCard:
      return {
        type: 'DebitCard',
        notiTypeCode: 'noticenter_display_debit',
        icon: 'noti-ctr__ico--check',
      }
    case NotiType.Deposit:
      return {
        type: 'Deposit',
        notiTypeCode: 'noticenter_display_term',
        icon: 'noti-ctr__ico--account',
      }
    case NotiType.TEST:
    case NotiType.QuickCash:
    case NotiType.QuickCredit:
      return {
        type: 'Loan',
        notiTypeCode: 'noticenter_display_accname',
        icon: 'noti-ctr__ico--loan',
      }
    default:
      return {
        type: '',
        notiTypeCode: '',
        icon: '',
      }
  }
}
